export default __webpack_public_path__ + "static/media/bg_modal_hotspot.8e47700c.jpg";